import { makeStyles, Theme } from '@material-ui/core';

import { FieldsEnum } from 'app/shared/enums';
import { makeSelectorByFieldKey } from 'app/shared/helpers/makeSelectorByFieldKey';

const withNegativeTopSpace = makeSelectorByFieldKey([
  FieldsEnum.CarMake,
  FieldsEnum.CarModel,
  FieldsEnum.CarRegistrationNumberNotKnown,
  FieldsEnum.OwnerNoDrivingLicense,
  FieldsEnum.OwnerLegalAddressCity,
  FieldsEnum.OwnerHomeAddressNotSameAsLegal,
  FieldsEnum.OwnerHomeAddressCity,
  FieldsEnum.Coowners1NoDrivingLicense,
  FieldsEnum.Coowners2NoDrivingLicense,
  FieldsEnum.TerminationApartmentNumber,
  FieldsEnum.TerminationCity,
  FieldsEnum.TerminationLastName,
  FieldsEnum.TerminationStreetName,
  FieldsEnum.TerminationStreetNumber,
  FieldsEnum.TerminationInsurerName,
  FieldsEnum.InsurantEmail,
  FieldsEnum.InexperiencedAdditionalDriverLicenseMonth,
]);

const withoutTopPadding = makeSelectorByFieldKey([
  FieldsEnum.CarRegistrationNumberNotKnown,
  FieldsEnum.InexperiencedAdditionalDriverLicenseMonth,
]);

const importedFromUsaCanada = makeSelectorByFieldKey([
  FieldsEnum.CarFirstRegistrationCountry,
]);

export const cepikConfirmationLabelClassName = 'cepikConfirmationLabel';

const answerLabel = `.MuiFormControlLabel-root:not(.${cepikConfirmationLabelClassName}) .MuiFormControlLabel-label`;

const borderedCheckboxLabel = {
  '&, & span': {
    color: '#3d3d3d',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },
};

const steeringWheelLocation = makeSelectorByFieldKey([
  FieldsEnum.CarDrivingWheelLocation,
]);

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette, shape }: Theme) => ({
    root: {
      backgroundColor: palette.common.white,
      padding: 20,
      borderRadius: shape.borderRadius,
      maxWidth: custom.form.maxWidth,
      position: 'relative',
      '& .tooltip': {
        position: 'absolute',
        top: -10,
        right: -50,
        marginLeft: 0,
        [breakpoints.down('sm')]: {
          top: -15,
          right: -15,
        },
      },
      [`${steeringWheelLocation}[data-field-error="true"]`]: {
        border: `4px solid ${custom.status.danger.contrastText}`,
      },
      [`${steeringWheelLocation} ${answerLabel}`]: borderedCheckboxLabel,
      [`${importedFromUsaCanada}[data-field-error="true"]`]: {
        border: `4px solid ${custom.status.danger.contrastText}`,
      },
      [`${importedFromUsaCanada} ${answerLabel}`]: borderedCheckboxLabel,
    },
    spaces: {
      marginBottom: 15,
      [withNegativeTopSpace]: {
        marginTop: -37,
        borderTop: 0,
      },
      [withoutTopPadding]: {
        paddingTop: 0,
      },
      [steeringWheelLocation]: {
        marginTop: -15,
      },
    },
    spacesWithoutMarginBottom: {
      [withNegativeTopSpace]: {
        marginTop: -37,
        borderTop: 0,
      },
      [withoutTopPadding]: {
        paddingTop: 0,
      },
    },
    noNegativeMarginTop: {
      [withNegativeTopSpace]: {
        marginTop: 0,
      },
    },
    noPadding: {
      padding: 0,
    },
  })
);
